import * as React from 'react';

import BusinessCardPhone from '@components/BusinessCard/BusinessCardPhone';
import BusinessCardText from '@components/BusinessCard/BusinessCardText';
import BusinessCardWrapper from '@components/BusinessCard/BusinessCardWrapper';
import Heading from '@components/Heading';
import Link from '@components/Link';
import Separator from '@components/Separator';

const BusinessCard = () => (
  <BusinessCardWrapper>
    <Heading level={1} as="h1">
      Todos
    </Heading>
    <BusinessCardText>
      Firma remontowo-budowlana,
      <br /> projektowanie wnętrz
    </BusinessCardText>
    <Separator width={50} />
    <Heading level={2} as="h2">
      Piotr Libelt
    </Heading>
    <BusinessCardPhone>
      <Link href="tel:+48504181307">504 181 307</Link>
    </BusinessCardPhone>
    <BusinessCardText>
      <Link href="mailto:piotrlibelt@todos.krakow.pl">
        piotrlibelt@todos.krakow.pl
      </Link>
    </BusinessCardText>
    <BusinessCardText>
      ul. Westerplatte 4/6
      <br />
      Kraków
    </BusinessCardText>
  </BusinessCardWrapper>
);

export default BusinessCard;
